import * as Yup from 'yup';
import { Param } from '../../../../../../shared/types/param';

export const initialValues: Param = {
    name: '',
    active: true,
    code: '',
    class: '',
    extra: '',
};

export const validationSchema = () =>
    Yup.object({
        name: Yup.string().required('El nombre es obligatorio'),
        extra: Yup.string().required('La descripción es obligatoria'),
    });
